import {endpoint} from '~/api';
import {IFeatureUpdate, normalizeFeature} from '~/modules/Features/models/Feature';

export const fetchFeatures = () =>
    endpoint.get<unknown[]>('/settings').then(r => r.data.map(normalizeFeature));

export const updateFeature = (name: string, update: IFeatureUpdate) =>
    endpoint.put<unknown>(`/settings/${encodeURIComponent(name)}`, update).then(r => normalizeFeature(r.data));
